import React from "react";
import { Icon } from "@bca/ui-library";

type MessageIconSizeType = "regular" | "large";
type MessageContextType = "message" | "warning";

export interface MessageIconProps {
  icon: string;
  context?: MessageContextType
  size?: MessageIconSizeType;
}

const MessageIcon: React.FunctionComponent<MessageIconProps> = ({ icon, context, size }) => {
  let color = "footer-blue";
  let width = "54px";

  if (context === "warning") color = "grey-blue";
  if (size === "large") width = "72px"

  return (
    <Icon name={icon} width={width} color={color} />
  )
}

export default MessageIcon;